import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core"
import { COMMON_IMPORTS } from "@app/common-imports"
import { Modalable } from "@app/Modalable"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { CancelBtnComponent } from "@app/utils/utils.component"

@Component({
	selector: "app-create-takbull-account",
	imports: [COMMON_IMPORTS, CancelBtnComponent, LangValPipe],
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		<div class="modal-btns">
			<app-cancel-btn (click)="onClose.emit()" />
			<button class="btn btn-primary">
				<a
					href="https://paypage.takbull.co.il/5ul0J"
					style="color:#fff;"
					target="”_blank”"
				>
					{{ "create_takbull_account" | langVal }}
				</a>
			</button>
		</div>
	`,
})
export class CreateTakbullAccountComponent extends Modalable {}
